import { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import api from '../../api/client.js';
import ExportButton from '../../components/ExportButton.jsx';

export default function AuditLog() {
  const [filters, setFilters] = useState({ action: '', entity: '', q: '', since: '' });

  const facets = useQuery({
    queryKey: ['audit-facets'],
    queryFn: () => api.get('/admin/audit-log/facets').then(r => r.data.data),
  });

  const list = useQuery({
    queryKey: ['audit-log', filters],
    queryFn: () => {
      const params = {};
      if (filters.action) params.action = filters.action;
      if (filters.entity) params.entity = filters.entity;
      if (filters.q) params.q = filters.q;
      if (filters.since) params.since = filters.since;
      return api.get('/admin/audit-log', { params }).then(r => r.data.data);
    },
  });

  return (
    <div className="space-y-4">
      <header className="flex items-center justify-between">
        <div>
          <div className="section-eyebrow">Admin</div>
          <h1 className="text-2xl">Activity log</h1>
          <div className="rule-crimson" />
        </div>
        <ExportButton path="/export/audit-log.csv" />
      </header>

      <div className="card p-3 grid grid-cols-2 sm:grid-cols-5 gap-2">
        <select className="input" value={filters.action}
                onChange={e => setFilters({ ...filters, action: e.target.value })}>
          <option value="">All actions</option>
          {facets.data?.actions?.map(a => <option key={a} value={a}>{a}</option>)}
        </select>
        <select className="input" value={filters.entity}
                onChange={e => setFilters({ ...filters, entity: e.target.value })}>
          <option value="">All entities</option>
          {facets.data?.entities?.map(e => <option key={e} value={e}>{e}</option>)}
        </select>
        <input className="input col-span-2" placeholder="Search…"
               value={filters.q} onChange={e => setFilters({ ...filters, q: e.target.value })} />
        <input className="input" type="datetime-local"
               value={filters.since} onChange={e => setFilters({ ...filters, since: e.target.value })} />
      </div>

      <div className="space-y-2">
        {list.isLoading && <div className="text-muted">Loading…</div>}
        {list.data?.length === 0 && <div className="text-muted">No matching events.</div>}
        {list.data?.map(row => (
          <div key={row.id} className="card p-3 text-sm">
            <div className="flex items-baseline justify-between gap-2 flex-wrap">
              <div>
                <span className="font-mono text-xs bg-panel px-1.5 py-0.5 rounded">{row.action}</span>
                {' '}
                <span className="font-medium">{row.entity}</span>
                {row.entity_id != null && <span className="text-muted"> #{row.entity_id}</span>}
              </div>
              <div className="text-xs text-muted">
                {row.user_email || 'anonymous'} · {new Date(row.at).toLocaleString()}
              </div>
            </div>
            {(row.before_state || row.after_state) && (
              <details className="mt-2">
                <summary className="cursor-pointer text-xs text-muted">details</summary>
                <pre className="mt-1 text-xs whitespace-pre-wrap break-words">
{row.before_state && 'before: ' + JSON.stringify(row.before_state, null, 2) + '\n'}
{row.after_state  && 'after: '  + JSON.stringify(row.after_state, null, 2)}
                </pre>
                {row.ip && <div className="text-xs text-muted mt-1">ip: {row.ip}</div>}
              </details>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
